define({
    // Arranging
    SEND_BACK:                  {value: 0, text: "arrange-send-back"},
    SEND_BACKWARD:              {value: 1, text: "arrange-send-backward"},
    BRING_FORWARD:              {value: 2, text: "arrange-bring-forward"},
    BRING_TO_FRONT:             {value: 3, text: "arrange-bring-to-front"},
    BRING_TO_TARGET:          {value: 4, text: "arrange-bring-to-specific"},

    // Aligning
    ALIGN_LEFT:                 {value: 0, text: "align-left"},
    ALIGN_CENTER:               {value: 1, text: "align-center"},
    ALIGN_RIGHT:                {value: 2, text: "align-right"},
    ALIGN_TOP:                  {value: 3, text: "align-top"},
    ALIGN_MIDDLE:               {value: 4, text: "align-middle"},
    ALIGN_BOTTOM:               {value: 5, text: "align-bottom"},

    // Distribute
    DISTRIBUTE_HORIZONTALLY:    {value: 6, text: "distribute-horizontally"},
    DISTRIBUTE_VERTICALLY:      {value: 7, text: "distribute-vertically"}
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/EditorConstants.js